module.exports = __webpack_public_path__ + "img/littie-code.ff4f962d.jpg";